/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {ViewPaymentMethods} from './viewPaymentMethods';
import {ViewTotals} from './viewTotals';
import AppDialog from '../../components/AppDialog';
import DialogContent from '@material-ui/core/DialogContent';

const useStyles = makeStyles({
  title: {
    fontWeight: 700,
  },
  card: {
    boxShadow: '0px 3px 6px #00000029',
    border: '1px solid #70707033',
    padding: '0!important',
  },
});

function CheckoutPay(props) {
  const classes = useStyles();

  return (
    <AppDialog
      disableClose={false}
      maxWidth={800}
      handleClose={props.handleClose}
      aria-labelledby="simple-dialog-title"
      open={props.open}
    >
      <DialogContent>
        <Container maxWidth="lg">
          <Box mt={4} mb={4}>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <Typography color="textPrimary" className={classes.title}>
                  ABONO
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ViewTotals value={props.value} />
                <Box my={3}>
                  <Divider />
                </Box>
                <div className={classes.card}>
                  <ViewPaymentMethods value={props.value} handleClose={props.handleClose} />
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </DialogContent>
    </AppDialog>
  );
}

export default CheckoutPay;
